export default __webpack_public_path__ + "static/media/NovoAnalise.eb7f8133.svg";